import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "antd";
import axios from 'axios';
import React, { useEffect, useImperativeHandle, useState } from "react";
import { isUserMultiTenant, userHasPermission } from "../../../../../swzutils/UserPermissionsUtil";
import HasPermissions from "../../../../../containers/HasPermissions";
import { axiosErrorHandler, showSuccessNotification } from "../../../../../swzutils";
import dayjs from "dayjs";
import { DeleteOutlined } from "@ant-design/icons";
import PaginatedFilterableTable, {} from "../../../components/table/PaginatedFilterableTable";
import { loggedInUserSelector, selectedTenantSelector } from "../../../../../store/slice/auth";
import { useAppSelector } from "../../../../../store";
const EmailSuppressionTable = (props, exportedRef) => {
    const tableRef = React.useRef(null);
    const [loading, setLoading] = useState(false);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const selectedTenant = useAppSelector(selectedTenantSelector);
    useImperativeHandle(exportedRef, () => ({
        refresh: () => {
            tableRef.current?.fetch();
        },
        downloadCsv: () => {
            tableRef.current?.downloadCurrentFilterAsCsv("email-suppressions");
        }
    }));
    useEffect(() => {
        refresh();
    }, [selectedTenant]);
    const refresh = () => {
        tableRef.current?.fetch();
    };
    const onSuppressionDeleted = (suppression) => {
        showSuccessNotification(`Suppression ${suppression.email} removed successfully.`);
        if (tableRef.current) {
            tableRef.current.removeRecordById(suppression.id);
        }
        else {
            refresh();
        }
    };
    const removeSuppression = (suppression) => {
        setLoading(true);
        axios.delete(`/admin/v1/email-suppressions/${suppression.id}`)
            .catch((error) => {
            axiosErrorHandler(error);
        })
            .then(() => onSuppressionDeleted(suppression))
            .finally(() => {
            setLoading(false);
        });
    };
    const columns = [{
            title: 'Recorded At',
            key: 'recordedAt',
            dataIndex: 'recordedAt',
            sorter: false,
            width: '10%',
            render: (text /*, record*/) => {
                return dayjs(text).format("DD/MM/YYYY HH:mm");
            }
        }, {
            key: 'emailAddress',
            title: 'Address',
            dataIndex: 'email',
            width: '20%'
        }, {
            key: 'type',
            title: 'Error',
            dataIndex: 'type',
            width: '10%'
        }, {
            key: 'error',
            title: 'Description',
            dataIndex: 'error',
            width: '30%'
        }, {
            key: "tenantId",
            title: 'Profile',
            dataIndex: ['tenant', 'name'],
            condition: isUserMultiTenant(loggedInUser),
            width: '20%'
        }, {
            key: 'action',
            title: 'Action',
            width: '10%',
            condition: userHasPermission(loggedInUser, ['admin:emailSuppression:delete']),
            render: (text, record) => (_jsx("span", { className: "actions", children: _jsx(HasPermissions, { permissions: ['admin:emailSuppression:delete'], children: _jsxs(Button, { onClick: () => removeSuppression(record), children: [_jsx(DeleteOutlined, {}), "\u00A0Remove"] }) }) }))
        }];
    return (_jsx(PaginatedFilterableTable, { tableKey: 'emailSuppressionTable', ref: tableRef, dataUri: "/admin/v1/email-suppressions", columns: columns, loading: loading }));
};
export default React.forwardRef(EmailSuppressionTable);
